// Mock data for marketing agency website

export const mockServices = [
  {
    id: 1,
    number: '01',
    title: '360° SOCIAL MEDIA MARKETING',
    description: 'We orchestrate the full journey from strategy, creative direction, on-site production to seamless digital distribution turning real-world presence into measurable attention and desire.',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=600&fit=crop'
  },
  {
    id: 2,
    number: '02',
    title: 'HIGH-END VIDEO PRODUCTION',
    description: 'We craft cinematic, high-impact video content from concept to final cut, covering scripting, filming, editing and platform-ready publishing, carefully designed to capture attention and elevate your brand across social channels.',
    image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&h=600&fit=crop'
  },
  {
    id: 3,
    number: '03',
    title: 'WEBSITES & DIGITAL PLATFORMS',
    description: 'We design and build modern, high-performance websites that clearly communicate credibility, authority and brand value, transforming first impressions into trust and action.',
    image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=600&fit=crop'
  },
  {
    id: 4,
    number: '04',
    title: 'BRANDBOOKS & VISUAL IDENTITY',
    description: 'We create cohesive brand systems, from visual identity and tone of voice to clear usage guidelines, ensuring your brand remains consistent, recognizable, and desirable across every touchpoint.',
    image: 'https://images.unsplash.com/photo-1558655146-d09347e92766?w=800&h=600&fit=crop'
  },
  {
    id: 5,
    number: '05',
    title: 'INFLUENCER MARKETING',
    description: 'We partner with carefully curated creators who authentically align with your brand—amplifying relevance, reinforcing positioning, and building trust through credible influence.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop'
  },
  {
    id: 6,
    number: '06',
    title: 'MEDIA BUY & TARGETED CAMPAIGNS',
    description: 'We execute precision-targeted advertising campaigns across Meta Ads, programmatic platforms, and premium outdoor locations—maximizing reach, engagement, and conversion while optimizing every dollar spent.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop'
  }
];

export const mockClients = [
  { 
    id: 1, 
    name: 'Delta Balamuc Resort', 
    logo: 'https://customer-assets.emergentagent.com/job_brand-showcase-98/artifacts/c1803kbk_617150086_122329939262011852_6454254229165173611_n.jpg' 
  },
  { 
    id: 2, 
    name: 'Mama Online', 
    logo: 'https://customer-assets.emergentagent.com/job_brand-showcase-98/artifacts/xz7emqa8_mamaonline-square-logo.png' 
  },
  { 
    id: 3, 
    name: 'Boosteroid', 
    logo: 'https://customer-assets.emergentagent.com/job_brand-showcase-98/artifacts/e2dmxw7l_31iCT0yWebL.png' 
  },
  { 
    id: 4, 
    name: 'Client 4', 
    logo: 'https://customer-assets.emergentagent.com/job_brand-showcase-98/artifacts/h6073x6l_unnamed.png' 
  }
];

export const mockStats = [
  { label: 'Years of Experience', value: '10+' },
  { label: 'Satisfied Clients', value: '200+' },
  { label: 'Projects Completed', value: '500+' },
  { label: 'Team Members', value: '50+' }
];
